import React, { useState, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import "../assets/css/ViewCustomer.css";
import axiosInstance from "../components/api/axiosInstance";
import { phoneCallLink } from "../utils/phone";
import { EmailLink, PhoneLink } from "../components/ContactLinks";

function ViewAccounts({ accountId, onBack, onEditAccount }) {
  const [accountData, setAccountData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAccount = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axiosInstance.get(`/accounts/${accountId}`);
        const account = response.data?.Account_Id
          ? response.data
          : (response.data?.data || response.data);
        setAccountData(account || null);
      } catch (err) {
        console.error("Error fetching account:", err);
        setError(err.response?.data?.message || "Failed to load account details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (accountId) fetchAccount();
  }, [accountId]);

  const InfoItem = ({ label, value }) => {
    const hasValue = value && value !== "—" && value !== "";
    return (
      <div className="viewlead-info-item">
        <span className={`viewlead-info-label ${hasValue ? "has-value" : ""}`}>{label}: </span>
        <span className={`viewlead-info-value ${!hasValue ? "muted" : ""}`}>{hasValue ? value : "—"}</span>
      </div>
    );
  };

  if (loading) return <div className="viewlead-container"><div className="viewlead-loading">Loading account details...</div></div>;
  if (error) return <div className="viewlead-container"><button className="viewlead-back-link" onClick={onBack}><FaArrowLeft /> Back to Accounts</button><div className="error-message" style={{ backgroundColor: "#fee", color: "#c33", padding: "12px", borderRadius: "4px", marginBottom: "20px", fontSize: "14px" }}>{error}</div></div>;
  if (!accountData) return <div className="viewlead-container"><button className="viewlead-back-link" onClick={onBack}><FaArrowLeft /> Back to Accounts</button><div className="viewlead-loading">Account not found.</div></div>;

  const account = accountData;

  return (
    <div className="viewlead-container">
      <div className="viewlead-header">
        <button className="viewlead-back-link" onClick={onBack}>
          <FaArrowLeft /> Back to Accounts
        </button>
        <button className="btn-edit-lead" onClick={() => onEditAccount && onEditAccount(accountId)}>
          Edit Account
        </button>
      </div>

      <div className="viewlead-card">
        <h3 className="viewlead-section-title">Account Information</h3>
        <div className="viewlead-info-grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
          <InfoItem label="Account ID" value={String(account.Account_Id || account.account_id || "")} />
          <InfoItem label="Platform Name" value={account.Platform_Name || account.platform_name} />
          <InfoItem label="Account Name" value={account.Account_Name || account.account_name} />
          <InfoItem label="Username" value={account.Username || account.username} />
        </div>

        <h3 className="viewlead-section-title">Contact Information</h3>
        <div className="viewlead-info-grid">
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", gridColumn: "1 / -1", alignItems: "stretch" }}>
            <div style={{ flex: "1 1 240px" }}>
              <InfoItem
                label="Contact Number"
                value={
                  phoneCallLink(account.Country_Code, account.Contact_Number) ? (
                    <PhoneLink countryCode={account.Country_Code} number={account.Contact_Number} />
                  ) : null
                }
              />
            </div>
            <div style={{ flex: "1 1 240px" }}>
              <InfoItem
                label="Email Used"
                value={account.Email_Used ? <EmailLink email={account.Email_Used} /> : null}
              />
            </div>
            <div style={{ flex: "1 1 240px" }}>
              <InfoItem label="URL" value={account.URL || account.url || account.Business_URL || account.business_url} />
            </div>
          </div>
        </div>

        <h3 className="viewlead-section-title">Additional Information</h3>
        <div className="viewlead-info-grid">
          <InfoItem label="Notes" value={account.Notes || account.notes || "—"} />
        </div>
      </div>
    </div>
  );
}

export default ViewAccounts;
